"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_model_tscommon_1 = require("@amzn/amazon-config-store-model-tscommon");
var OFFLINE_CONFIG_FOLDER = (_a = {},
    _a[amazon_config_store_model_tscommon_1.ClientStage.SANDBOX] = 'sandbox/',
    _a[amazon_config_store_model_tscommon_1.ClientStage.DEVO] = 'devo/',
    _a[amazon_config_store_model_tscommon_1.ClientStage.PROD] = '',
    _a);
exports.default = OFFLINE_CONFIG_FOLDER;
